export const topConfig = self => [
  {
    label: '1',
    name: self.$t('219') // 置顶
  },
  {
    label: '0',
    name: self.$t('224')
  }
]

export const btnConfig = self => [
  {
    label: '1',
    name: self.$t('162') // 所有人
  },
  {
    label: '2',
    name: self.$t('864')
  },
  {
    label: '3',
    name: self.$t('865')
  }
]

export const mustReadConfig = self => [
  {
    label: '0',
    name: self.$t('1800') // 否
  },
  {
    label: '1',
    name: self.$t('1801')
  }
]

export const categoryConfig = self => [
  {
    label: '1',
    name: self.$t('1694') // 普通消息
  },
  {
    label: '4',
    name: self.$t('1695') // 签字消息
  }
]
